export const LOADING = "LOADING";
export const ACCOUNTINFO = "ACCOUNTINFO";
export const ACCOUNTINFO_ERROR = "ACCOUNTINFO_ERROR";
export const EMPTY_ERROR_COMMON_OBJ = "EMPTY_ERROR_COMMON_OBJ";
export const SUBSCRIPTIONACCOUNTINFO = "SUBSCRIPTIONACCOUNTINFO";
export const SUBSCRIPTIONACCOUNTINFO_ERROR = "SUBSCRIPTIONACCOUNTINFO_ERROR";
export const UPDATEACCOUNTINFO = "UPDATEACCOUNTINFO";
export const UPDATEACCOUNTINFO_ERROR = "UPDATEACCOUNTINFO_ERROR";
export const MAILALERTINFO_ERROR = "MAILALERTINFO_ERROR";
export const MAILALERTINFO = "MAILALERTINFO_ERROR";
export const USAGEACCOUNTINFO = "USAGEACCOUNTINFO";
export const USAGEACCOUNTINFO_ERROR = "USAGEACCOUNTINFO_ERROR";
export const UPDATEPASSWORDINFO_ERROR = "UPDATEPASSWORDINFO_ERROR";
export const UPDATEPASSWORDINFO = "UPDATEPASSWORDINFO_ERROR";
export const USAGELEADACCOUNTINFO = "USAGELEADACCOUNTINFO";
export const USAGELEADACCOUNTINFO_ERROR = "USAGELEADACCOUNTINFO_ERROR";
export const FORGOTPASSWORDINFO = "FORGOTPASSWORDINFO";
export const FORGOTPASSWORDINFO_ERROR = "FORGOTPASSWORDINFO_ERROR";
export const RESETPASSWORDINFO = "RESETPASSWORDINFO";
export const RESETPASSWORDINFO_ERROR = "RESETPASSWORDINFO_ERROR";
